import Vue from 'vue';

export const columns = (state) => (
  Object.values(state.columns)
    .sort((a, b) => a.order - b.order)
);

export const columnsLoading = (state) => state.columnsLoading;

export const hasColumns = (state) => !!Object.values(state.columns).length;

export const getUseOnlyMyActivities = (state, getters, rootState, rootGetters) => (kanbanId) => (
  rootGetters['Usuario/currentUserId'] === kanbanId
);

export const getActivitiesOfBoard = (state, getters) => (kanbanId, columnValue) => {
  const index = state[kanbanId] || {};
  const useOnlyMyActivities = getters.getUseOnlyMyActivities(kanbanId);
  return Object
    .values(index)
    .filter((activity) => (useOnlyMyActivities ? activity.targetUserId === kanbanId : true))
    .filter((activity) => activity.statusValue === columnValue)
    .sort((a, b) => Vue.moment(b.updatedAt).diff(Vue.moment(a.updatedAt)));
};

export const getActivity = (state) => (kanbanId, activityId) => {
  const kanbanIndex = state[kanbanId] || {};
  return kanbanIndex[activityId] || {};
};

export const getBinnacleOfActivity = (state) => (activityId) => {
  const { data = [] } = state.binnacle[activityId] || {};
  return data.sort((a, b) => Vue.moment(b.date).diff(Vue.moment(a.date)));
};

export const isBinnacleOfActivityLoading = (state) => (activityId) => {
  const { isLoading = false } = state.binnacle[activityId] || {};
  return isLoading;
};

export const columnsActivities = (state) => state.columnsActivities;
